<template>
  <div class="tree">
    <div v-for="item in treeList" :key="item.id">
      <van-cell
        :title="item.name"
        is-link
        @click="(index) => checkGetTree(item.type, item.id)"
      >
        <template v-if="item.type === 'staff'" #title>
          <div class="title">
            <svg-icon icon-class="staff_avatar" style="font-size: 0.35rem" />
            <div class="value">
              <span class="name">{{ item.name }}</span>
            </div>
          </div>
        </template>
        <template #right-icon>
          <div v-if="item.type === pickName">
            <van-checkbox-group v-if="pickType === 'multiple'" v-model="newPickedList">
              <van-checkbox :ref="`checkboxes${item.id}`" :name="item.id" @change="(e) => onChange(e, item.id)" />
            </van-checkbox-group>
            <van-radio-group v-else v-model="newPickedList">
              <van-radio :name="item.id" />
            </van-radio-group>
          </div>
          <svg-icon v-else icon-class="arrow-r" class="icon" @click.stop="() => getTree(item.id)" />
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>

import { Checkbox, CheckboxGroup, RadioGroup, Radio } from 'vant';
export default {
  name: 'Index',
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: ['treeList', 'pickType', 'pickName', 'pickedList'],
  data() {
    return {
    };
  },
  computed: {
    newPickedList: {
      get() {
        return this.pickedList;
      },
      set(val) {
        this.$emit('update:pickedList', val);
      }
    }
  },
  created() {
  },
  methods: {
    getTree(id) {
      this.$emit('getTree', id);
    },
    checkGetTree(type, id) {
      if (type !== 'staff') {
        this.getTree(id);
      }
    },
    onChange(e, id) {
      const data = { checked: e, id: id };
      this.$emit('onChange', data);
    }
  }
};
</script>

<style lang="less" scoped>
.tree {
  .title {
    display: flex;
    align-items: center;
    .value {
      display: flex;
      flex-direction: column;
      margin-left: 0.05rem;
      .name {
        font-size: 0.17rem;
        font-weight: 400;
        line-height: 0.24rem;
        color: #001833;
      }
      .department {
        font-size: 0.14rem;
        font-weight: 400;
        line-height: 0.2rem;
        color: #333333;
      }

    }
  }
}
</style>
